
<div class="slogin-container">
  <div class="slogin-left-panel">
    <div class="slogin-quadrant-grid">
      <div class="slogin-quadrant slogin-red">
        <i class="fas fa-chart-line slogin-quadrant-icon"></i>
        <span>Applicants Support</span>
      </div>
      <div class="slogin-quadrant slogin-green">
        <i class="fas fa-headset slogin-quadrant-icon"></i>
        <span>Integrated Experience</span>
      </div>
      <div class="slogin-quadrant slogin-yellow">
        <i class="fas fa-chart-bar slogin-quadrant-icon"></i>
        <span>Accelerated Business</span>
      </div>
      <div class="slogin-quadrant slogin-blue">
        <i class="fas fa-globe-americas slogin-quadrant-icon"></i>
        <span>The future of Student Support</span>
      </div>
    </div>
  </div>

  <div class="slogin-right-panel">
    <div class="slogin-form-container">
      <img 
        src="https://techbridge.edu.gh/static/TUC_LOGO_1.png" 
        alt="Techbridge Logo" 
        class="slogin-top-logo"
        loading="lazy"
      >

      <h1 class="slogin-welcome-title">Welcome</h1>
      <p class="slogin-welcome-subtitle">to Techbridge Admin Portal</p>
      
      <form class="slogin-form-section" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        
        <div *ngIf="errorMessage" class="slogin-error-message">
          <i class="fas fa-exclamation-circle"></i>
          <span>{{ errorMessage }}</span>
        </div>

        <div class="slogin-input-group">
          <label for="username" class="slogin-input-label">Username</label>
          <div class="slogin-input-container">
            <input 
              id="username" 
              name="username" 
              class="slogin-form-input" 
              type="text" 
              formControlName="username"
              [class.slogin-error]="isUsernameInvalid"
              placeholder="Enter your username"
              autocomplete="username"
            >
          </div>
          <div *ngIf="isUsernameInvalid" class="slogin-field-error">
            <span *ngIf="username?.errors?.['required']">Username is required</span>
            <span *ngIf="username?.errors?.['minlength']">Username must be at least 3 characters</span>
          </div>
        </div>
        
        <div class="slogin-input-group">
          <label for="password" class="slogin-input-label">Password</label>
          <div class="slogin-input-container">
            <input 
              id="password" 
              name="password" 
              class="slogin-form-input" 
              [type]="showPassword ? 'text' : 'password'" 
              formControlName="password"
              [class.slogin-error]="isPasswordInvalid"
              placeholder="Enter your password"
              autocomplete="current-password"
            >
            <i 
              class="fas slogin-password-toggle" 
              [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'" 
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
            ></i>
          </div>
          <div *ngIf="isPasswordInvalid" class="slogin-field-error">
            <span *ngIf="password?.errors?.['required']">Password is required</span>
            <span *ngIf="password?.errors?.['minlength']">Password must be at least 6 characters</span>
          </div>
        </div>

        <div class="slogin-button-group">
          <button 
            type="submit" 
            class="slogin-login-button" 
            [disabled]="isLoading"
            [attr.aria-label]="isLoading ? 'Signing in...' : 'Sign in to your account'"
          >
            <span class="slogin-button-content">
              <ng-container *ngIf="isLoading; else signInText">
                <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
                <span>Signing in...</span>
              </ng-container>
              <ng-template #signInText>
                <i class="fas fa-sign-in-alt" aria-hidden="true"></i>
                <span>Sign In</span>
              </ng-template>
            </span>
          </button>
        </div>
      </form>
    </div>

    <!-- Footer -->
    <div class="slogin-footer-container">
      <p class="slogin-copyright">Techbridge | UITS © 2026 All rights reserved</p>
    </div>
  </div>
</div>